import { AccountPermissionDto } from '@treasury/api/bo/overrides';
import { DomainEntity } from '../../../../shared';
import { FromAccountPermission } from './product-features/from-account-permission.entity';

export class AccountPermission extends DomainEntity<AccountPermissionDto> {
    public createDefault(): this {
        throw new Error('not implemented');
    }

    public get accountType() {
        return this.dto.toAccountType;
    }

    public set accountType(type: string) {
        this.dto.toAccountType = type;
    }

    public get fromAccountTypes() {
        return this.dto.fromAccountTypes.map(fromAccount => new FromAccountPermission(fromAccount));
    }

    public set fromAccountTypes(types: FromAccountPermission[]) {
        this.dto.fromAccountTypes = types.map(fromAccount => fromAccount.toDto());
    }

    public get id() {
        return this.dto.id;
    }

    public set id(value: number) {
        this.dto.id = value;
    }
}
